export default {
    computed: {
        taskType() {
            return this.$store.getters.taskTypeById(this.taskTypeId)
        },
    },
}
